import React from "react";
import {Image} from 'react-bootstrap';

import "./Qualfication.css";

import certificate_ico from "../../asset/images/certificate_ico.webp";
import icon_new from "../../asset/images/icon_new.png";
import icon_energy_saving from "../../asset/images/icon_energy_saving.png";
import icon_credit from "../../asset/images/icon_credit.png";
import icon_excellent from "../../asset/images/icon_excellent.png";

import img_13 from "../../asset/images/img_13.png";
import img_12 from "../../asset/images/img_12.png";
import img_11 from "../../asset/images/img_11.png";
import img_03 from "../../asset/images/img_03.png";
import img_09 from "../../asset/images/img_09.png";
import img_10 from "../../asset/images/img_10.png";

import img_01 from "../../asset/images/img_01.png";
import img_02 from "../../asset/images/img_02.png";
import img_04 from "../../asset/images/img_04.png";
import img_05 from "../../asset/images/img_05.png";
import img_06 from "../../asset/images/img_06.png";
import img_07 from "../../asset/images/img_07.png";
import img_08 from "../../asset/images/img_08.png";


// 资质证书
class Qualfication extends React.Component {
  render() {
    return (
      <div>
        <div className="certificate">
          <Image src={certificate_ico} className="certificate_ico" />
          <div className="certificate_cards">
            <div className="certificate_card">
              <div className="certificate_card_up">
                <Image className="certificate_card_ico" src={icon_new}/>
                <div className="certificate_card_word">
                  <div className="certificate_card_title">高新技术企业</div>
                  <div className="certificate_card_content">国家级高新技术企业</div>
                </div>
              </div>
              <Image className="certificate_card_img" src={img_11} />
            </div>
            <div className="certificate_card">
              <div className="certificate_card_up">
                <Image className="certificate_card_ico" src={icon_energy_saving}/>
                <div className="certificate_card_word">
                  <div className="certificate_card_title">节能协会会员</div>
                  <div className="certificate_card_content">中国节能协会节能服务产业委员会</div>
                </div>
              </div>
              <Image className="certificate_card_img" src={img_03} />
            </div>
            <div className="certificate_card">
              <div className="certificate_card_up">
                <Image className="certificate_card_ico" src={icon_new}/>
                <div className="certificate_card_word">
                  <div className="certificate_card_title">高新技术企业</div>
                  <div className="certificate_card_content">中关村高新技术企业</div>
                </div>
              </div>
              <Image className="certificate_card_img" src={img_12} />
            </div>
            <div className="certificate_card">
              <div className="certificate_card_up">
                <Image className="certificate_card_ico" src={icon_credit}/>
                <div className="certificate_card_word">
                  <div className="certificate_card_title">重合同守信用企业</div>
                  <div className="certificate_card_content">中国节能协会节能服务产业委员会</div>
                </div>
              </div>
              <Image className="certificate_card_img" src={img_09} />
            </div>
            <div className="certificate_card">
              <div className="certificate_card_up">
                <Image className="certificate_card_ico" src={icon_excellent}/>
                <div className="certificate_card_word">
                  <div className="certificate_card_title">合同能源管理优秀示范项目</div>
                  <div className="certificate_card_content">中国节能协会节能服务产业委员会</div>
                </div>
              </div>
              <Image className="certificate_card_img" src={img_10} />
            </div>
          </div>
          <div className="intellectual">
            <div className="intellectual_word">
              <div className="intellectual_title">知识产权</div>
              <div className="intellectual_content">取得多项发明专利、软件著作权等知识产权，广泛运用于实施中的数字化用能项目并取得显著成效</div>
            </div>
            <div className="intellectual_imgs">
              <Image className="intellectual_img" src={img_01} />
              <Image className="intellectual_img" src={img_02} />
              <Image className="intellectual_img" src={img_04} />
              <Image className="intellectual_img" src={img_05} />
              <Image className="intellectual_img" src={img_06} />
              <Image className="intellectual_img" src={img_07} />
              <Image className="intellectual_img" src={img_08} />
              <Image className="intellectual_img" src={img_13} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Qualfication
